export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL
  ? `${process.env.REACT_APP_API_BASE_URL}/api/v1`
  : "http://localhost:9000/api/v1";

export const MANAGER = "Manager";
export const APPUSER = "App User";
export const ADMIN = "Admin";
export const SUPER_ADMIN = "Super Admin";
export const VISO_SUPER_ADMIN = "VISO Super Admin";
export const DASHBOARD_EDITOR = "Dashboard Editor";

export const API_URLS = {
  AUTH: {
    LOGIN: `${BASE_API_URL}/auth/login`,
    CHANGE_PASSWORD: `${BASE_API_URL}/auth/change_password`,
    RESET_PASSWORD: `${BASE_API_URL}/auth/reset_password`,
    REFRESH_TOKEN: `${BASE_API_URL}/auth/refresh_token`,
  },
  COMPANY: {
    GET_COMPANIES: `${BASE_API_URL}/input/company-mgmt/get_companies`,
    CREATE_COMPANY: `${BASE_API_URL}/input/company-mgmt/create_company`,
    UPDATE_COMPANY: `${BASE_API_URL}/input/company-mgmt/update_company`,
    DELETE_COMPANY: `${BASE_API_URL}/input/company-mgmt/delete_company`,
    DOWNLOAD_COMPANY_IMAGES: `${BASE_API_URL}/input/company-mgmt/download_company_images`,
    GET_ASSET_TYPES: `${BASE_API_URL}/input/company-mgmt/get_asset_types`,
  },
  COMPANY_CONFIG: {
    GET_COMPANY_CONFIGURATION: `${BASE_API_URL}/input/company-mgmt/get_company_configuration`,
    CREATE_COMPANY_CONFIGURATION: `${BASE_API_URL}/input/company-mgmt/create_company_configuration`,
    UPDATE_COMPANY_CONFIGURATION: `${BASE_API_URL}/input/company-mgmt/update_company_configuration`,
    DELETE_COMPANY_CONFIGURATION: `${BASE_API_URL}/input/company-mgmt/delete_company_configuration`,
  },
  YARD: {
    GET_YARDS_BY_COMPANY_ID: `${BASE_API_URL}/input/yard-mgmt/get_yards`,
    CREATE_YARD: `${BASE_API_URL}/input/yard-mgmt/create_yard`,
    UPDATE_YARD: `${BASE_API_URL}/input/yard-mgmt/update_yard`,
    DELETE_YARD: `${BASE_API_URL}/input/yard-mgmt/delete_yard`,
    GET_SITE_TYPES: `${BASE_API_URL}/input/yard-mgmt/get_site_types`,
  },
  GATE: {
    GET_GATES_BY_YARD_IDS: `${BASE_API_URL}/dashboard/gate-mgmt/get_gates_by_yard_ids`,
  },
  SESSION: {
    GET_SESSIONS_BY_GATE_IDS_AND_DATE: `${BASE_API_URL}/dashboard/session-mgmt/get_sessions_by_gate_ids_and_date`,
    GET_SESSION_SKUS_DETAILS: `${BASE_API_URL}/dashboard/session-mgmt/get_session_skus_details`,
    GET_GATE_STATUS_OVERVIEW: `${BASE_API_URL}/dashboard/session-mgmt/get_gate_status_overview`,
    GET_WAREHOUSE_CARGO_SUMMARY: `${BASE_API_URL}/dashboard/session-mgmt/get_warehouse_cargo_summary`,
    GET_HOURLY_THROUGHPUT: `${BASE_API_URL}/dashboard/session-mgmt/get_hourly_throughput`,
  },
  SHIPPING_LINES: {
    GET_SHIPPING_LINES_BY_COMPANY: `${BASE_API_URL}/dashboard/shipping-line-mgmt/get_shipping_lines_by_company`,
    GET_SHIPPING_LINES_BY_YARDS: `${BASE_API_URL}/dashboard/shipping-line-mgmt/get_shipping_lines_by_yards`,
    CREATE_SHIPPING_LINE: `${BASE_API_URL}/dashboard/shipping-line-mgmt/create_shipping_line`,
    UPDATE_SHIPPING_LINE: `${BASE_API_URL}/dashboard/shipping-line-mgmt/update_shipping_line`,
    DELETE_SHIPPING_LINE: `${BASE_API_URL}/dashboard/shipping-line-mgmt/delete_shipping_line`,
  },
  USER: {
    GET_USERS: `${BASE_API_URL}/input/user-mgmt/get_users`,
    GET_MANAGERS: `${BASE_API_URL}/input/user-mgmt/get_managers`,
    CREATE_USER: `${BASE_API_URL}/input/user-mgmt/create_user`,
    UPDATE_USER: `${BASE_API_URL}/input/user-mgmt/update_user`,
    DELETE_USER: `${BASE_API_URL}/input/user-mgmt/delete_user`,
    UPDATE_USER_STATUS: `${BASE_API_URL}/input/user-mgmt/update_user_status`,
  },
  ROLE: {
    GET_ROLES: `${BASE_API_URL}/input/role-mgmt/get_roles`,
    CREATE_ROLE: `${BASE_API_URL}/input/role-mgmt/create_role`,
    UPDATE_ROLE: `${BASE_API_URL}/input/role-mgmt/update_role`,
    DELETE_ROLE: `${BASE_API_URL}/input/role-mgmt/delete_role`,
    GET_ROLE_NAMES: `${BASE_API_URL}/input/role-mgmt/get_role_names`,
  },
  MACHINE: {
    GET_MACHINES: `${BASE_API_URL}/input/machine-mgmt/get_machines`,
    GET_COMPANY_YARD_MACHINES: `${BASE_API_URL}/input/machine-mgmt/get_company_yard_machines`,
    ATTACH_MACHINE: `${BASE_API_URL}/input/machine-mgmt/attach_machine`,
    DETACH_MACHINE: `${BASE_API_URL}/input/machine-mgmt/detach_machine`,
  },
  SCAN: {
    GET_LATEST_SURVEY_DATE: `${BASE_API_URL}/dashboard/scan-mgmt/get_latest_survey_date`,
    GET_REPORT_STATS: `${BASE_API_URL}/dashboard/scan-mgmt/get_report_stats`,
    GET_SCANS_BY_YARDS_AND_DATE: `${BASE_API_URL}/dashboard/scan-mgmt/get_scans_by_yards_and_date`,
    GET_SCANS_BY_YARDS_AND_DAYS: `${BASE_API_URL}/dashboard/scan-mgmt/get_scans_by_yards_and_days`,
    GET_SCAN_STAGE_REPORT: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_stage_report`,
    UPDATE_DEFECT_SIGNIFICANCE: `${BASE_API_URL}/dashboard/scan-mgmt/update_defect_significance`,
    UPDATE_REPORTED_TO_MANAGER: `${BASE_API_URL}/dashboard/scan-mgmt/update_reported_to_manager`,
    UPDATE_REPORT_PUBLISHED: `${BASE_API_URL}/dashboard/scan-mgmt/update_report_published`,
    GET_SCAN_PDF: `${BASE_API_URL}/desktop/scan-mgmt/get_scan_pdf`,
    GET_SCAN_IMAGES_ZIP: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_images_zip`,
    UPDATE_SCAN_INFO: `${BASE_API_URL}/dashboard/scan-mgmt/update_scan_info`,
    DELETE_SCAN: `${BASE_API_URL}/dashboard/scan-mgmt/delete_scan`,
    UPDATE_SCAN_STAGE_INFO: `${BASE_API_URL}/dashboard/scan-mgmt/update_scan_stage_info`,
    CREATE_CUSTOM_DEFECT: `${BASE_API_URL}/dashboard/scan-mgmt/create_custom_defect`,
    UPDATE_SCAN_STAGE_DEFECT: `${BASE_API_URL}/dashboard/scan-mgmt/update_scan_stage_defect`,
    UPDATE_SCAN_STAGE_IMAGES: `${BASE_API_URL}/dashboard/scan-mgmt/update_scan_stage_images`,
    GET_SCAN_BY_CONTAINER_NUMBER: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_by_container_number`,
  },
  PUBLIC_REPORT: {
    GET_SCAN_STAGE_REPORT: `${BASE_API_URL}/public/report-mgmt/get_scan_stage_report`,
    GET_SCAN_PDF: `${BASE_API_URL}/public/report-mgmt/get_scan_pdf`,
    GET_SCAN_IMAGES_ZIP: `${BASE_API_URL}/public/report-mgmt/get_scan_images_zip`,
    GET_PUBLIC_LINK_BY_CONTAINER: `${BASE_API_URL}/public/report-mgmt/get_link_by_container`,
    GET_CONTAINER_LOCATION: `${BASE_API_URL}/public/report-mgmt/get_container_location`,
    GET_COMPANY_YARD_INFO: `${BASE_API_URL}/public/report-mgmt/get_company_yard_info`,
    GET_LATEST_CONTAINER_LOCATION: `${BASE_API_URL}/public/report-mgmt/get_latest_container_location`
  },
  TAG_SCAN: {
    GET_COMPANY_TRIPS: `${BASE_API_URL}/dashboard/tag-scan-mgmt/get_company_trips`,
    GET_TRIP_JOURNEY: `${BASE_API_URL}/dashboard/tag-scan-mgmt/get_trip_journey`,
    GET_LIVE_PLANT_VIEW: `${BASE_API_URL}/dashboard/tag-scan-mgmt/get_live_plant_view`,
    GET_COMPANY_BAYS: `${BASE_API_URL}/dashboard/tag-scan-mgmt/get_company_bays`,
    GET_BAY_VISITS: `${BASE_API_URL}/dashboard/tag-scan-mgmt/get_bay_visits`,
  },
  VEHICLE_TAG: {
    CREATE_VEHICLE_TAG: `${BASE_API_URL}/input/vehicle-tag-mgmt/create_vehicle_tag`,
    GET_COMPANY_VEHICLES: `${BASE_API_URL}/input/vehicle-tag-mgmt/get_company_vehicles`,
    DELETE_VEHICLE_TAG: `${BASE_API_URL}/input/vehicle-tag-mgmt/delete_vehicle_tag`,
  },
};
